<template>
  <component :is="component" :pointData="pointData" :paginationData="paginationData" v-if="component"></component>
</template>

<script>
export default {
  name: "PointListLink",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{
    }
  },
  props: {
    listLayout: '',
    pointData: {default: () => []},
    paginationData: {default: {page: 1, size: 10, total: 0}},
  },
  data() {
    return{
      component: null,
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
    this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/template/point/list/PointListDefaultLayout')
        })
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
    loader() {
      if (!this.listLayout) {
        return null
      }
      return () => import(`@/template/point/list/${this.listLayout}`)
    },
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>
